module.exports = __webpack_public_path__ + "media/images/mobile-only/element01-587113fd1b77a405b9c52f442cb2ce56.png";